import { withBasePath } from '@/utils/basePath';

export const LOGOS = [
  {
    alt: 'Google Drive Logo',
    height: 160,
    src: withBasePath('/images/adaptative/google-drive.svg'),
    width: 160,
  },
  {
    alt: 'OneDrive Logo',
    height: 160,
    src: withBasePath('/images/adaptative/one-drive.svg'),
    width: 160,
  },
  {
    alt: 'Sharepoint Logo',
    height: 160,
    src: withBasePath('/images/adaptative/sharepoint.svg'),
    width: 160,
  },
  {
    alt: 'Synology Logo',
    height: 160,
    src: withBasePath('/images/adaptative/synology.svg'),
    width: 240,
  },
  {
    alt: 'Dropbox Logo',
    height: 160,
    src: withBasePath('/images/adaptative/dropbox.svg'),
    width: 160,
  },
  {
    alt: 'Tresorit Logo',
    height: 160,
    src: withBasePath('/images/adaptative/tresorit.svg'),
    width: 160,
  },
  {
    alt: 'pCloud Logo',
    height: 160,
    src: withBasePath('/images/adaptative/pcloud.svg'),
    width: 160,
  },
];
